import partial from 'lodash/partial';
import { HEADER_BANNERS_TYPES } from 'consts/headerBanners';
import headerBannersSlice from './slice';

export const { pushBack, popFront, reset } = headerBannersSlice.actions;

const _pushBack = (type, data) => pushBack({ type, data });

export const pushBackDownloadExtensionBanner = partial(_pushBack, HEADER_BANNERS_TYPES.downloadExtension);
